import React from "react"
import PropTypes from 'prop-types'

const Group = ({
  style = {},
  fill = "white",
  width = "100%",
  className = "group",
  viewBox = "0 0 24 24"
}) => (
  <svg
    width={width}
    style={style}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path
        d="M18 14a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm-9-3a4 4 0 1 1 0-8 4 4 0 0 1 0 8z"
        fill={fill}
        fillRule="nonzero"
        opacity=".44"
      />
      <path
        d="M17.601 15c3.407.038 6.188 1.76 6.397 5.4.009.147 0 .6-.542.6H19.6c0-2.25-.744-4.328-1.999-6zm-17.6 5.2C.388 15.426 4.26 13 8.983 13c4.788 0 8.722 2.293 9.015 7.2.012.195 0 .8-.751.8H.727c-.25 0-.747-.54-.726-.8z"
        fill={fill}
        fillRule="nonzero"
      />
    </g>
  </svg>
)

Group.propTypes = {
  style: PropTypes.object,
  fill: PropTypes.string,
  width: PropTypes.string,
  className: PropTypes.string,
  viewBox: PropTypes.string
}

export default Group
